import React, { useEffect } from "react";
import { ConfirmationModal } from "../../components";
import { useToggleActivationMutation } from "../../store";

const UserActivation = ({ show, onHide, id, isActive }) => {
  const [toggleActivation, { isLoading, isSuccess, error }] =
    useToggleActivationMutation();

  const handleActivation = (e) => {
    e.preventDefault();
    toggleActivation(id);
  };
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title={`${isActive ? "Deactivate" : "Activate"} Appraiser Account`}
      body={`Do you really want to ${isActive ? "Deactivate" : "Activate"
        } this Appraiser's Account ?`}
      successMessage={`Appraiser's Account ${isActive ? "Deactivated" : "Activated"
        } Successfully!`}
      submitHandler={handleActivation}
      reducerProps={{
        loading: isLoading,
        success: isSuccess,
        error,
      }}
    ></ConfirmationModal>
  );
};

export default UserActivation;
